// src/components/auth/RegistrationSuccess.jsx
import React from 'react';
import {
    Typography,
    Container,
    Box,
    Button,
    Card,
    CardContent,
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

export default function RegistrationSuccess() {
    return (
        <Box
            sx={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background:
                    'linear-gradient(135deg, rgba(255,165,0,0.08) 0%, rgba(0,0,0,0.02) 100%)',
                py: 6,
            }}
        >
            <Container maxWidth="sm">
                <Card
                    elevation={0}
                    sx={{
                        borderRadius: 4,
                        boxShadow: '0 20px 60px rgba(0,0,0,0.08)',
                        textAlign: 'center',
                        p: { xs: 3, md: 4 },
                    }}
                >
                    <CardContent>
                        <CheckCircleOutlineIcon
                            sx={{ fontSize: 72, color: 'green', mb: 2 }}
                        />

                        <Typography variant="h4" fontWeight={700} gutterBottom>
                            Registrierung erfolgreich
                        </Typography>

                        <Typography variant="body1" color="text.secondary" gutterBottom>
                            Willkommen bei <strong>Schreiberlein</strong>! <br />
                            Dein Account wurde erfolgreich angelegt.
                        </Typography>

                        <Button
                            component={RouterLink}
                            to="/login"
                            variant="contained"
                            sx={{
                                mt: 3,
                                backgroundColor: 'orange',
                                '&:hover': { backgroundColor: '#cc7a00' },
                                borderRadius: 2,
                                px: 4,
                                py: 1.2,
                                fontWeight: 600,
                            }}
                        >
                            Jetzt einloggen
                        </Button>
                    </CardContent>
                </Card>
            </Container>
        </Box>
    );
}
